// extracted by mini-css-extract-plugin
module.exports = {"outer":"FullPageWrapper_outer__3GRh2","inner":"FullPageWrapper_inner__2gphU"};